import axios from '../modules/AxiosInstance';
import Environment from '../modules/Environment';
import store from '../store';
import UriUtils from '../modules/UriUtils';
import { PAYIT_TENANT_USER_ID, } from '../modules/Constants';

const PropertyTaxService = (() => {
  const service = {};
  const BASE_URL = `${Environment.getBaseURL()}`;

  const formatHeaders = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return headers;
  };

  service.taxAccountSearch = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/property-tax-accounts/search${queryString}`, {
      headers,
    });
  };

  service.getBillByAccountId = (criteria) => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;

    const queryString = UriUtils.toQueryString(criteria);
    return axios.get(`${BASE_URL}/property-tax-bills/search${queryString}`, {
      headers,
    });
  };

  service.linkToAccount = ({ serviceOfferingId, customerId, accountId, }) => {
    const headers = formatHeaders();
    return axios.post(
      `${BASE_URL}/serviceOfferingId/${serviceOfferingId}/accounts/link`,
      {
        serviceOfferingId,
        customerId,
        accountIds: [ accountId, ],
      },
      {
        headers,
      }
    );
  };

  service.unlinkFromAccount = ({ serviceOfferingId, customerId, accountId, }) => {
    const headers = formatHeaders();
    return axios.post(
      `${BASE_URL}/serviceOfferingId/${serviceOfferingId}/accounts/unlink`,
      {
        serviceOfferingId,
        customerId,
        accountIds: [ accountId, ],
      },
      {
        headers,
      }
    );
  };

  service.getAllPTAXServiceOfferings = () => {
    const { authentication, } = store.getState().auth;
    const headers = {};
    headers.Authorization = authentication.token;
    headers[PAYIT_TENANT_USER_ID] = authentication.tenantUserId;
    return axios.get(`${BASE_URL}/ptax-offerings`, {
      headers,
    });
  };

  return service;
})();

export default PropertyTaxService;
